import { createAsyncThunk } from "@reduxjs/toolkit";
import { buildUrl } from "../api";
import { BoschAxios } from "../../api/BoschAxios";
import UserService from "../../utils/UserService";

export const login: any = createAsyncThunk("login", async (data) => {
  let baseRequest = await buildUrl({ route: "login" });
  return BoschAxios(baseRequest.route, baseRequest.method, data, null);
});

export const logout: any = createAsyncThunk("logout", async (data) => {
  return true;
});

export const getUser: any = createAsyncThunk("getUser", async () => {
  let baseRequest = await buildUrl({ route: "getUserInfo" });
  let token = UserService.getToken();
  if (token) {
    localStorage.setItem("token", token);
  }
  return BoschAxios(baseRequest.route, baseRequest.method, null, token);
});
